import { useRouter } from 'next/router';

import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../hooks/queries/properties';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../styles/wizard';

import AddEditPhoneNumber from '../../../PostingPath/AddEditPhoneNumber';
import PageWizard from '../../../Wizard/PageWizard';
import WizardTipCardContainer from '../../../WizardTipCardContainer';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const PhoneNumber = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
    >
      <div data-testid="PhoneNumber">
        <Box css={wizardFlexContainerStyles}>
          <Box css={wizardFormSectionContainerStyles.raw()}>
            <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
              Verify your phone number
            </Heading>

            <Paragraph css={wizardParagraphStyles}>
              For your security, Zillow will send a one time verification code to this number to verify that this
              listing belongs to you.
            </Paragraph>

            <AddEditPhoneNumber />
          </Box>

          {listingDetails?.trackingPhoneNumber && (
            <WizardTipCardContainer
              header="How is my number used?"
              showDesktopViewBreakpoint={showDesktopViewBreakpoint}
            >
              <Paragraph>
                To protect your identity, the phone number renters see will differ from your actual number. You’ll
                receive calls and texts like normal, but your information is protected.
              </Paragraph>
            </WizardTipCardContainer>
          )}
        </Box>
      </div>
    </PageWizard>
  );
};

export default PhoneNumber;
